/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('CompanyImage_Resource',["$resource","$location", function ($resource,$location){
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource(baseUrl+'rest/companyImages/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' },
            clearCache:   { method: 'POST', url:baseUrl+'rest/companyImages/clearCache' }
        });
    }]);

angular.module('FlexyBeautyApp.services').
    factory('CompanyImage', function (){

        var  CompanyImage = function (resource)
        {
            this.id = null;
            this.fileName=null;
            this.label=null;
            this.keyWords=null;
            this.urlHD=null;
            this.url=null;
            this.urlPreview=null;
            this.size=null;
            this.type = null;
            this.dim = null;
            this.filterType = null;
            if (resource!==undefined && resource!=null)
            {
                if (!this.id)
                    this.id = resource.id;
                this.fileName =  resource.fileName;
                this.label = resource.label;
                this.keyWords = resource.keyWords;
                if (resource.url)
                    this.url = resource.url.replace("http:","");
                if (resource.urlHD)
                    this.urlHD = resource.urlHD.replace("http:","");
                else
                    this.urlHD = this.url;
                if (resource.urlPreview)
                    this.urlPreview =  resource.urlPreview.replace("http:","");
                this.size=resource.size;
                this.type=resource.type;
                if(this.type == 'customer')
                    this.filterType = true;
                else
                    this.filterType = false;
                this.dim =resource.dim;
            }

        }

        return  CompanyImage;
    });
angular.module('FlexyBeautyApp.services').
    factory('CompanyImageSrv',["CompanyImage_Resource","CompanyImage","CompanyImageData","ServerSrv","$log","bugsnag","Constants",
        function (CompanyImage_Resource,CompanyImage,CompanyImageData,ServerSrv,$log,bugsnag,Constants){
        var  companyImageSrv = {};

        companyImageSrv.query = function(successFunction,errorFunction)
        {
            CompanyImage_Resource.query(
                {}, //params
                (data) => {   //success
                    CompanyImageData.clear();
                    for (var i=0;i< data.length;i++)
                        CompanyImageData.add(new CompanyImage(data[i]));

                    if (successFunction!== undefined)
                        successFunction(CompanyImageData.companyImages);

                },
                (data) => {
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);
                    CompanyImage_Resource.clearCache({},
                        () => {
                            //nothing to do
                        },
                        (error) => {
                            bugsnag.notify("CompanyImage_Resource.clearCache - Error during companyImage clearCache", `ClearCache failure. Error : ${error.message}`, {}, Constants.BUGSNAG_NOTIFICATION_LEVEL);
                        });
                });
        };
            companyImageSrv.remove =  function(companyImage,successFunction,errorFunction)
            {
                CompanyImageData.remove(companyImage);
                ServerSrv.startSavingProcess(companyImageSrv.removeSync, companyImage, successFunction, errorFunction);
            };
            companyImageSrv.removeSync =  function(companyImage,successFunction,errorFunction)
            {
                var companyImageRes = new CompanyImage_Resource()
                companyImageRes.$remove({id:companyImage.id}, //params : id
                    function (data) {
                        try {
                            if (successFunction != undefined)
                                successFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(true);
                        }
                    },
                    function (data) {   //failure
                        //error handling goes here
                        try {
                            if (errorFunction != undefined)
                                errorFunction(data);
                        }
                        finally {
                            ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                        }
                    }
                );
            };
        return companyImageSrv;
    }]);
angular.module('FlexyBeautyApp.services').
    factory('CompanyImageData', function (){
        var  companyImageData = {companyImages : []};
        companyImageData.getById =  function(companyImageId)
        {
            for (var i=0;i<this.companyImages.length;i++)
                if (this.companyImages[i].id==companyImageId)
                    return this.companyImages[i];
            return null;
        }
        companyImageData.add =  function(companyImage)
        {
            this.companyImages.push(companyImage);
        }
        companyImageData.remove =  function(companyImage)
        {
            var index =  this.companyImages.indexOf(companyImage);
            if (index!=-1)
                this.companyImages.splice(index, 1);
        }
        companyImageData.clear =  function()
        {
            this.companyImages = [];
        };
        companyImageData.getActiveList =  function(type)
        {
            if (type===undefined)
                return this.companyImages;
            var images = [];
            for(var i=0;i<this.companyImages.length;i++)
                if (this.companyImages[i].type == type || (this.companyImages[i].type == null && type == "" )) {
                    images.push(this.companyImages[i]);
                }
            return images;
        }
       companyImageData.getActiveListWithoutCustomerImages =  function()
       {
           var images = [];
           for(var i = 0; i < this.companyImages.length; i++)
               if (this.companyImages[i].type != 'customer' || (this.companyImages[i].type == null && type == "" )) {
               images.push(this.companyImages[i]);
           }
           return images;
       }
        return companyImageData;
    });


// WEBPACK FOOTER //
// ./js/services/models/CompanyImage.js